import createPersistedState from "vuex-persistedstate";

const getTimeZone = function () {
  let tzStr = 'Europe/Kiev';
  try {
    tzStr = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (e) {}
  return tzStr;
}

/**
 * Form data
 */
export const emptyData = {
  professionalId: '',
  professionalName: '',
  clientId: '',
  bookingId: '',

  /**
   * Form data
   */
  client: [],
  username: '',
  userphone: '',
  serviceId: '',
  date: '',
  datetime: '',
  hour: '',
  reminder: 0,
  search: '',
  services: {},
  professionalServicesList: {},
  comment: '',
  sum: 0,
  minutes: 0,
  hours: '',
  currency: '',
  workTime: {},

  /**
   * Data for mount
   */
  startsCount: 0,

  /**
   * Data for request
   */
  clientLang: navigator.language || navigator.userLanguage || 'ru-RU',
  clientTimezone: getTimeZone(),
  clientDevice: 'desctop',

  successMessage: '',
  errorMessage: '',
};

export default {
  state: {
    /**
     * Arrays
     */
    app: {
      professional: {

      },
      booking: {

      },
    },

    /**
     * Common data
     */
    days: [
      'Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'
    ],
    months: [
      "Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
      "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"
    ],
    currenciesLocal: {
      'UAH': 'ГРН'
    },
    reminderList: [
        {
            "id": "1",
            "title": "За день до",
            "value": "12:00"
        },
        {
            "id": "2",
            "title": "6 часов",
            "value": "6:00"
        },
        {
            "id": "3",
            "title": "2 часа",
            "value": "2:00"
        },
        {
            "id": "4",
            "title": "1 час",
            "value": "1:00"
        }
    ],
    phone: '',
  },
  mutations: {
    addState(state, emptyData) {
      state.app[window.APP_MODE][window.STATE_KEY] = emptyData;
    },
    startsCount (state) {
      state.app[window.APP_MODE][window.STATE_KEY].startsCount++;
    },
    startsCountValue (state, value) {
      state.app[window.APP_MODE][window.STATE_KEY].startsCountValue = value;
    },
    startsCounDrop (state) {
      state.app[window.APP_MODE][window.STATE_KEY].startsCount = 0;
    },
    professionalId(state, professionalId) {
      state.app[window.APP_MODE][window.STATE_KEY].professionalId = professionalId;
    },
    professionalName(state, professionalName) {
      state.app[window.APP_MODE][window.STATE_KEY].professionalName = professionalName;
    },
    client(state, client) {
      state.app[window.APP_MODE][window.STATE_KEY].client = client;
    },
    clientTimezone(state, clientTimezone) {
      state.app[window.APP_MODE][window.STATE_KEY].clientTimezone = clientTimezone;
    },
    date(state, date) {
      state.app[window.APP_MODE][window.STATE_KEY].date = date;
    },
    datetime(state, datetime) {
      state.app[window.APP_MODE][window.STATE_KEY].datetime = datetime;
    },
    hour(state, hour) {
      state.app[window.APP_MODE][window.STATE_KEY].hour = hour;
    },
    search: (state, value) => {
      state.app[window.APP_MODE][window.STATE_KEY].search = value;
    },
    workTime: (state, workTime) => {
      state.app[window.APP_MODE][window.STATE_KEY].workTime = workTime;
    },
    professionalServicesList: (state, professionalServicesList) => {
      state.app[window.APP_MODE][window.STATE_KEY].professionalServicesList = professionalServicesList;
    },
    services: (state, obj) => {
      state.app[window.APP_MODE][window.STATE_KEY].services[obj.keyName] = obj.value;
    },
    clearServices: (state) => {
      state.app[window.APP_MODE][window.STATE_KEY].services = {};
    },
    reminder: (state, value) => {
      state.app[window.APP_MODE][window.STATE_KEY].reminder = value;
    },
    username: (state, value) => {
      state.app[window.APP_MODE][window.STATE_KEY].username = value;
    },
    userphone: (state, value) => {
      state.app[window.APP_MODE][window.STATE_KEY].userphone = value;
    },
    comment: (state, comment) => {
      state.app[window.APP_MODE][window.STATE_KEY].comment = comment;
    },
    sum: (state, sum) => {
      state.app[window.APP_MODE][window.STATE_KEY].sum = sum;
    },
    hours: (state, hours) => {
      state.app[window.APP_MODE][window.STATE_KEY].hours = hours;
    },
    minutes: (state, minutes) => {
      state.app[window.APP_MODE][window.STATE_KEY].minutes = minutes;
    },
    currency: (state, currency) => {
      state.app[window.APP_MODE][window.STATE_KEY].currency = currency;
    },
    successMessage: (state, successMessage) => {
      state.app[window.APP_MODE][window.STATE_KEY].successMessage = successMessage;
    },
    errorMessage: (state, errorMessage) => {
      state.app[window.APP_MODE][window.STATE_KEY].errorMessage = errorMessage;
    },
    phone: (state, value) => {
      state.phone = value;
    },
  },
  actions: {
    addState (context, emptyData) {
      context.commit('addState', emptyData);
    },
    startsCount (context) {
      context.commit('startsCount');
    },
    startsCountValue(context, value) {
      context.commit('startsCountValue', value);
    },
    startsCounDrop (context) {
      context.commit('startsCounDrop');
    },
    professionalId(context, professionalId) {
      context.commit('professionalId', professionalId);
    },
    professionalName(context, professionalName) {
      context.commit('professionalName', professionalName);
    },
    date(context, date) {
      context.commit('date', date);
    },
    client(context, client) {
      context.commit('client', client);
    },
    clientTimezone(context, client) {
      context.commit('clientTimezone', client);
    },
    datetime(context, datetime) {
      context.commit('datetime', datetime);
    },
    hour(context, hour) {
      context.commit('hour', hour);
    },
    workTime(context, workTime) {
      context.commit('workTime', workTime);
    },
    search: (context, value) => {
      context.commit('search', value)
    },
    services: (context, obj) => {
      context.commit('services', obj)
    },
    professionalServicesList: (context, obj) => {
      context.commit('professionalServicesList', obj)
    },
    clearServices: (context) => {
      context.commit('clearServices')
    },
    reminder: (context, value) => {
      context.commit('reminder', value)
    },
    username: (context, value) => {
      context.commit('username', value)
    },
    userphone: (context, value) => {
      context.commit('userphone', value)
    },
    comment: (context, value) => {
      context.commit('comment', value)
    },
    hours: (context, value) => {
      context.commit('hours', value)
    },
    minutes: (context, value) => {
      context.commit('minutes', value)
    },
    sum: (context, value) => {
      context.commit('sum', value)
    },
    currency: (context, value) => {
      context.commit('currency', value)
    },
    successMessage: (context, value) => {
      context.commit('successMessage', value)
    },
    errorMessage: (context, value) => {
      context.commit('errorMessage', value)
    },
    phone: (context, value) => {
      context.commit('phone', value)
    },
  },
  getters: {
    emptyData () {
      return emptyData;
    },
    getState (state) {
      return state.app[window.APP_MODE][window.STATE_KEY];
    },
    startsCount (state) {
      return state.app[window.APP_MODE][window.STATE_KEY].startsCount;
    },
    clientLang: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].clientLang;
    },
    clientTimezone: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].clientTimezone;
    },
    clientDevice: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].clientDevice;
    },
    professionalName(state) {
      return state.app[window.APP_MODE][window.STATE_KEY].professionalName;
    },
    professionalId(state) {
      return state.app[window.APP_MODE][window.STATE_KEY].professionalId;
    },
    date(state) {
      return state.app[window.APP_MODE][window.STATE_KEY].date;
    },
    client(state) {
      return state.app[window.APP_MODE][window.STATE_KEY].client;
    },
    datetime(state) {
      return state.app[window.APP_MODE][window.STATE_KEY].datetime;
    },
    hour(state) {
      return state.app[window.APP_MODE][window.STATE_KEY].hour;
    },
    workTime(state) {
      return state.app[window.APP_MODE][window.STATE_KEY].workTime;
    },
    search: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].search;
    },
    services: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].services;
    },
    professionalServicesList: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].professionalServicesList;
    },
    reminder: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].reminder;
    },
    username: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].username;
    },
    userphone: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].userphone;
    },
    comment: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].comment;
    },
    sum: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].sum;
    },
    hours: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].hours;
    },
    minutes: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].minutes;
    },
    currency: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].currency;
    },
    successMessage: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].successMessage;
    },
    errorMessage: (state) => {
      return state.app[window.APP_MODE][window.STATE_KEY].errorMessage;
    },

    days: (state) => {
      return state.days;
    },
    months: (state) => {
      return state.months;
    },
    currenciesLocal: (state) => {
      return state.currenciesLocal;
    },
    reminderList: (state) => {
      return state.reminderList;
    },
    phone: (state) => {
      return state.phone;
    },
  },
  plugins: [createPersistedState()]
};
